import React from "react";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_SINGLE_POST } from "../graphql/GET_SINGLE_POST";
import "./blogdetail.css";

const FallbackCardImg = "https://snasso.quintbrothers.com/wp-content/uploads/2025/09/defulat-image-scaled.webp";

export default function BlogDetails() {
  const { slug } = useParams();

  const { data, loading, error } = useQuery(GET_SINGLE_POST, { variables: { slug } });
  const { data: recentData, loading: recentLoading } = useQuery(GET_SINGLE_POST, {
    variables: { first: 6 },
  });

  if (loading) return <div className="blog-single loading">Loading…</div>;
  if (error)   return <div className="blog-single error">Error: {error.message}</div>;

  const post = data?.post;
  if (!post) return <div className="blog-single">Not found</div>;

  const hero = post.featuredImage?.node?.sourceUrl || null;
  const heroAlt = post.featuredImage?.node?.altText || post.title;

  const recent = recentData?.posts?.nodes ?? [];

  return (
    <section className="blog-detail-wrap">
      <div className="container">
        <div className="grid">
          {/* LEFT: Article */}
          <article className="content-col">
            <nav className="crumbs">
              <Link to="/">Home</Link> <span>›</span> <Link to="/blogs">Blog</Link> <span>›</span>
              <span className="current">{post.title}</span>
            </nav>

            <header className="blog-header">
              <h1 className="title" dangerouslySetInnerHTML={{ __html: post.title }} />
              <p className="meta">
                {new Date(post.date).toLocaleDateString()}
              </p>
              {hero && (
                <figure className="hero">
                  <img src={hero} alt={heroAlt} loading="lazy" />
                </figure>
              )}
            </header>

            <div
              className="blog-content"
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
          </article>

          {/* RIGHT: Sticky Sidebar */}
          <aside className="sidebar-col">
            <div className="sticky">
              <h3 className="sidebar-title">Recent Posts</h3>
              {recentLoading && <div className="recent-skel">Loading…</div>}

              <ul className="recent-list">
                {recent.map((rp) => {
                  const img = rp?.featuredImage?.node?.sourceUrl || FallbackCardImg;
                  const alt = rp?.featuredImage?.node?.altText || rp.title;
                  return (
                    <li key={rp.id} className="recent-item">
                      <Link to={`/blog/${rp.slug}`} className="recent-card">
                        <div className="thumb">
                          <img src={img} alt={alt} loading="lazy" />
                        </div>
                        <div className="info">
                          <h4 className="recent-title" dangerouslySetInnerHTML={{ __html: rp.title }} />
                          <time className="recent-date">
                            {new Date(rp.date).toLocaleDateString()}
                          </time>
                        </div>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
